<template>
	<div class="warehouse-container">
		<s-select-definition
			:def="1423"
			@getDataInitial="GetColumns($event)"
			hidden
		></s-select-definition>
		<s-select-definition
			:def="1424"
			@getDataInitial="GetRows($event)"
			hidden
		></s-select-definition>

		<!-- Filtros Section -->
		<div class="filters-section" v-if="!notFilter">
			<v-card class="filter-card" elevation="2">
				<v-card-title class="filter-header">
					<v-icon color="primary" class="mr-2">mdi-filter-variant</v-icon>
					<h3 class="filter-title">Filtros de Búsqueda</h3>
				</v-card-title>
				<v-card-text class="filter-content">
					<v-row>
						<v-col cols="12" md="6" lg="4">
							<s-select-definition
								label="Tipo de Selección"
								:def="1318"
								clearable
								v-model="FilterDoll.TypeSelectionFrozen"
								@input="FilterDollSearch()"
								outlined
								dense
							></s-select-definition>
						</v-col>
						<v-col cols="12" md="6" lg="4">
							<s-select-definition 
								label="Estado" 
								:def="1326"
								clearable
								v-model="FilterDoll.TypeFrozenCategory"
								@input="FilterDollSearch()"
								outlined
								dense
							></s-select-definition>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</div>

		<!-- Warehouse Grid Section -->
		<div class="warehouse-section">
			<v-card class="warehouse-card" elevation="3">
				<v-card-title class="warehouse-header">
					<div class="header-content">
						<div class="header-left">
							<v-icon color="primary" class="mr-2">mdi-warehouse</v-icon>
							<h3 class="warehouse-title">Plataforma de Muñecos</h3>
						</div>
						<div class="header-right" v-if="!notFilter">
							<v-chip
								class="weight-chip"
								color="primary"
								text-color="white"
								label
							>
								<v-icon left small>mdi-weight</v-icon>
								{{ WeightSend | numberDefaultKg }}
							</v-chip>
						</div>
					</div>
				</v-card-title>
				
				<v-card-text class="warehouse-content">
					<!-- Grid sin filtros -->
					<div class="warehouse-grid" v-if="!filterBoolean && !notFilter">
						<div 
							class="column-section"
							v-for="item in columns"
							:key="item.DedAbbreviation"
						>
							<div class="column-header">
								<h4>{{ item.DedDescription }}</h4>
							</div>
							<div class="column-slots">
								<div 
									class="slot-card"
									v-for="item2 in rows"
									:key="item2.DedAbbreviation"
								>
									<template v-if="getSlotDolls(item.DedDescription + item2.DedDescription).length > 0">
										<div 
											class="occupied-slot"
											@click="sendTable(getSlotDolls(item.DedDescription + item2.DedDescription))"
											:class="getSlotStatusClass(getSlotDolls(item.DedDescription + item2.DedDescription)[0])"
										>
											<div class="slot-content">
												<div class="slot-position">
													{{ item.DedDescription + item2.DedDescription }}
												</div>
												<div class="slot-info">
													<div class="slot-quantity">
														<v-icon small color="white">mdi-package-variant</v-icon>
														{{ getTotalQuantity(getSlotDolls(item.DedDescription + item2.DedDescription)) }} jabas
													</div>
													<div class="slot-items" v-if="getSlotDolls(item.DedDescription + item2.DedDescription).length > 1">
														<v-icon small color="white">mdi-layers</v-icon>
														{{ getSlotDolls(item.DedDescription + item2.DedDescription).length }} items
													</div>
												</div>
												<div class="slot-details">
													<div class="slot-type">
														{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].TypeSelectionFrozenName }}
													</div>
													<div class="slot-category">
														{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].TypeFrozenCategoryName }}
													</div>
												</div>
												<v-chip
													class="slot-code"
													color="rgba(255,255,255,0.2)"
													text-color="white"
													x-small
												>
													{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].DlpCodBase }}
												</v-chip>
											</div>
										</div>
									</template>
									<template v-else>
										<div 
											class="empty-slot"
											@click="emitLocation({item, item2})"
										>
											<div class="empty-content">
												<v-icon color="success" size="24">mdi-plus-circle</v-icon>
												<div class="empty-position">
													{{ item.DedDescription + item2.DedDescription }}
												</div>
												<div class="empty-text">Disponible</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>

					<div class="warehouse-grid" v-if="!filterBoolean && notFilter" style="user-select: none;">
						<div 
							class="column-section"
							v-for="item in columns"
							:key="item.DedAbbreviation"
						>
							<div class="column-header">
								<h4>{{ item.DedDescription }}</h4>
							</div>
							<div class="column-slots">
								<div 
									class="slot-card"
									v-for="item2 in rows"
									:key="item2.DedAbbreviation"
								>
									<template v-if="getSlotDolls(item.DedDescription + item2.DedDescription).length > 0">
										<div 
											class="occupied-slot"
											@click="getSlotDolls(item.DedDescription + item2.DedDescription)[0].DlpTypeDiscard == 3 ? 
												emitLocation({item, item2}) : ''"
											:class="getSlotStatusClass(getSlotDolls(item.DedDescription + item2.DedDescription)[0])"
											:style="getSlotDolls(item.DedDescription + item2.DedDescription)[0].DlpTypeDiscard == 3 ? '' : 'opacity: 0.5'"
										>
											<div class="slot-content">
												<div class="slot-position">
													{{ item.DedDescription + item2.DedDescription }}
												</div>
												<div class="slot-info">
													<div class="slot-quantity">
														<v-icon small color="white">mdi-package-variant</v-icon>
														{{ getTotalQuantity(getSlotDolls(item.DedDescription + item2.DedDescription)) }} jabas
													</div>
													<div class="slot-items" v-if="getSlotDolls(item.DedDescription + item2.DedDescription).length > 1">
														<v-icon small color="white">mdi-layers</v-icon>
														{{ getSlotDolls(item.DedDescription + item2.DedDescription).length }} items
													</div>
												</div>
												<div class="slot-details">
													<div class="slot-type">
														{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].TypeSelectionFrozenName }}
													</div>
													<div class="slot-category">
														{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].TypeFrozenCategoryName }}
													</div>
												</div>
												<v-chip
													class="slot-code"
													color="rgba(255,255,255,0.2)"
													text-color="white"
													x-small
												>
													{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].DlpCodBase }}
												</v-chip>
											</div>
										</div>
									</template>
									<template v-else>
										<div 
											class="empty-slot"
											@click="emitLocation({item, item2})"
										>
											<div class="empty-content">
												<v-icon color="success" size="24">mdi-plus-circle</v-icon>
												<div class="empty-position">
													{{ item.DedDescription + item2.DedDescription }}
												</div>
												<div class="empty-text">Disponible</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>

					<!-- Grid con filtros -->
					<div class="warehouse-grid" v-if="filterBoolean">
						<div 
							class="column-section"
							v-for="item in columnsFilter"
							:key="item.DedAbbreviation"
						>
							<div class="column-header">
								<h4>{{ item.DedDescription }}</h4>
							</div>
							<div class="column-slots">
								<div 
									class="slot-card"
									v-for="item2 in rows"
									:key="item2.DedAbbreviation"
								>
									<template v-if="getSlotDolls(item.DedDescription + item2.DedDescription).length > 0">
										<div 
											class="occupied-slot"
											@click="sendTable(getSlotDolls(item.DedDescription + item2.DedDescription))"
											:class="getSlotStatusClass(getSlotDolls(item.DedDescription + item2.DedDescription)[0])"
										>
											<div class="slot-content">
												<div class="slot-position">
													{{ item.DedDescription + item2.DedDescription }}
												</div>
												<div class="slot-info">
													<div class="slot-quantity">
														<v-icon small color="white">mdi-package-variant</v-icon>
														{{ getTotalQuantity(getSlotDolls(item.DedDescription + item2.DedDescription)) }} jabas
													</div>
													<div class="slot-items" v-if="getSlotDolls(item.DedDescription + item2.DedDescription).length > 1">
														<v-icon small color="white">mdi-layers</v-icon>
														{{ getSlotDolls(item.DedDescription + item2.DedDescription).length }} items
													</div>
												</div>
												<div class="slot-details">
													<div class="slot-type">
														{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].TypeSelectionFrozenName }}
													</div>
													<div class="slot-category">
														{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].TypeFrozenCategoryName }}
													</div>
												</div>
												<v-chip
													class="slot-code"
													color="rgba(255,255,255,0.2)"
													text-color="white"
													x-small
												>
													{{ getSlotDolls(item.DedDescription + item2.DedDescription)[0].DlpCodBase }}
												</v-chip>
											</div>
										</div>
									</template>
									<template v-else>
										<div 
											class="empty-slot"
											@click="emitLocation({item, item2})"
										>
											<div class="empty-content">
												<v-icon color="success" size="24">mdi-plus-circle</v-icon>
												<div class="empty-position">
													{{ item.DedDescription + item2.DedDescription }}
												</div>
												<div class="empty-text">Disponible</div>
											</div>
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</div>

		<!-- Dialog -->
		<v-dialog 
			v-model="dialogDoll"
			v-if="dialogDoll"
			persistent
			max-width="900px"
		>
			<InfoTable 
				:dolls="dolls"	
				:filter="filter"			
				:IsTransfer="0"
				@CloseDialogInfoTable="CloseDialogInfoTable()"
				@RefreshStore="RefreshStore()"
			/>
		</v-dialog>
	</div>
</template>

<script>
import _armedDoolService from '@/services/FrozenProduction/ArmedDollService'
import _sTurnService from '@/services/FreshProduction/PrfTurnService'
import InfoTable from '@/views/FrozenProduction/FrzCtnLinesProcess/InfoTable'

export default {
	components: {
		InfoTable
	},
	props: {
		armed: {
			type: Boolean,
			required: false,
			default: false
		},
		filter: {
			type: Object,
			default: null
		},
		notFilter: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			columns: [],
			rows: [],
			dollStore: [],
			dialogDoll: false,
			dolls: [],
			FilterDoll: {
				TypeSelectionFrozen: null,
				TypeFrozenCategory: null,
				TrnID: null
			},
			activeTurn: null,
			itemsDollFilter: [],
			filterBoolean: false,
			columnsFilter: [],
			JabasSend: 0,
			WeightSend: 0,
		}
	},
	watch: {
		filter: {
			handler() {
				this.clickFilterDoll();
			},
			deep: true
		}
	},
	methods: {
		async loadActiveTurn() {
			try {
				const r = await _sTurnService.turnActive({ TypeArea: 4 }, this.$fun.getUserID());
				if (r.status === 200 && r.data.length > 0) {
					this.activeTurn = r.data[0];
				}
			} catch (e) {
				console.error("Error loading active turn in LocationDoll:", e);
			}
		},
		// Método para obtener muñecos de un slot específico
		getSlotDolls(position) {
			return this.dollStore.filter(doll => doll.DlpPosition == position);
		},
		
		// Método para obtener la cantidad total de jabas en un slot
		getTotalQuantity(dolls) {
			return dolls.reduce((total, doll) => total + doll.DlpQuantity, 0);
		},
		
		// Método para obtener la clase de estado del slot
		getSlotStatusClass(doll) {
			if (doll.DlpTypeDiscard == 1) return 'slot-status-good';
			if (doll.DlpTypeDiscard == 2) return 'slot-status-warning';
			if (doll.DlpTypeDiscard == 3) return 'slot-status-danger';
			return '';
		},
		
		CloseDialogInfoTable() {
			this.dialogDoll = false;
			this.clickFilterDoll();
		},
		
		sendTable(dolls) {
			console.log('wasaaa', dolls);
			this.dolls = dolls;
			this.dialogDoll = true;
			console.log('this.dolls1', this.dolls);
			console.log("Filter1111111", this.filter);
		},
		
		emitLocation(item) {
			this.$emit("emitLocation", item)
		},
		
		GetColumns(items) {
			this.columns = items;
		},
		
		GetRows(items) {
			this.rows = items;
		},
		
		listStore() {
			const trnID = this.filter?.TrnID || this.filter?.TurnID || (this.activeTurn ? this.activeTurn.TrnID : null);
			_armedDoolService.listStore({ TypeCultive: this.filter?.TypeCultive, TrnID: trnID }, this.$fun.getUserID())
				.then((r) => {
					if (r.status == 200) {
						this.dollStore = r.data;
						console.log('this.dollStore', this.dollStore);
					}
				})
		},
		
		FilterDollSearch() {
			this.columnsFilter = [];
			let columnF = [];
			
			if (this.FilterDoll.TypeFrozenCategory != null && this.FilterDoll.TypeSelectionFrozen == null) {
				columnF = this.dollStore.filter(doll => 
					doll.TypeFrozenCategory == this.FilterDoll.TypeFrozenCategory);
			} else if (this.FilterDoll.TypeSelectionFrozen != null && this.FilterDoll.TypeFrozenCategory == null) {
				columnF = this.dollStore.filter(doll => 
					doll.TypeSelectionFrozen == this.FilterDoll.TypeSelectionFrozen);
			} else {
				columnF = this.dollStore.filter(doll => 
					doll.TypeSelectionFrozen == this.FilterDoll.TypeSelectionFrozen
					&& doll.TypeFrozenCategory == this.FilterDoll.TypeFrozenCategory);
			}
			
			columnF.forEach(column => {
				column.DedDescription = column.DlpCol;
			});
			
			let ladovisto = {};
			columnF.forEach(column => { 
				let lado = column.DlpCol;
				if (!ladovisto[lado]) {
					ladovisto[lado] = true;
					this.columnsFilter.push(column);
				}
			})
			
			this.columnsFilter.sort((a, b) => {
				if (a.DlpCol < b.DlpCol) return -1;
				if (a.DlpCol > b.DlpCol) return 1;
				return 0;
			});
			
			this.filterBoolean = !(this.FilterDoll.TypeFrozenCategory == null && this.FilterDoll.TypeSelectionFrozen == null);
		},
		
		async clickFilterDoll() {
			if (!this.activeTurn) {
				await this.loadActiveTurn();
			}
			const trnID = this.filter?.TrnID || this.filter?.TurnID || (this.activeTurn ? this.activeTurn.TrnID : null);
			this.FilterDoll.TypeCultive = this.filter?.TypeCultive;
			this.FilterDoll.TrnID = trnID;
			_armedDoolService.listDollFilter(this.FilterDoll, this.$fun.getUserID()).then(r => {
				if (r.status == 200) {
					console.log('r.dataaaaaaE', r.data);
					this.dollStore = r.data;
					this.WeightSend = 0;
					this.dollStore.forEach(d => {
						this.WeightSend += d.AverageWeightJabaN;
					});
				}
			})
		},
		
		RefreshStore() {
			this.listStore();
		}
	},
	async mounted() {
		await this.loadActiveTurn();
		this.clickFilterDoll();
		console.log("dollStore", this.dollStore);
		console.log("FilterGaaaaaaaa", this.filter);
	}
}
</script>

<style scoped>
/* .warehouse-container {
	padding: 20px;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	min-height: 100vh;
} */

/* Filtros */
.filters-section {
	margin-bottom: 24px;
}

.filter-card {
	border-radius: 12px;
	border: none;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.filter-header {
	/* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
	color: #1A1A1A;
	border-radius: 12px 12px 0 0;
	padding: 16px 24px;
}

.filter-title {
	margin: 0;
	font-weight: 600;
	font-size: 1.25rem;
}

.filter-content {
	padding: 24px;
}

/* Warehouse Section */
.warehouse-section {
	margin-bottom: 24px;
}

.warehouse-card {
	border-radius: 12px;
	border: none;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.warehouse-header {
	/* background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); */
	/* background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%); */
	/* color: white; */
	color: #1A1A1A;
	border-radius: 12px 12px 0 0;
	padding: 20px 24px;
}

.header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.header-left {
	display: flex;
	align-items: center;
}

.warehouse-title {
	margin: 0;
	font-weight: 600;
	font-size: 1.5rem;
}

.weight-chip {
	font-weight: 600;
	font-size: 1rem;
	padding: 0 16px;
	height: 36px;
}

.warehouse-content {
	padding: 24px;
	background: #fafbfc;
}

/* Grid Layout */
.warehouse-grid {
	display: flex;
	gap: 20px;
	overflow-x: auto;
	justify-content: center;
	/* padding: 10px; */
}

.column-section {
	min-width: 200px;
	flex-shrink: 0;
}

.column-header {
	text-align: center;
	margin-bottom: 16px;
	padding: 12px;
	/* background: linear-gradient(135deg, #4467ff 0%, #739dff 100%); */
	background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
	color: white;
	border-radius: 8px;
	font-weight: 600;
}

.column-header h4 {
	margin: 0;
	font-size: 1.1rem;
}

.column-slots {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.slot-card {
	border-radius: 8px;
	overflow: hidden;
	transition: all 0.3s ease;
}

/* Occupied Slot */
.occupied-slot {
	/* background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); */
	color: white;
	padding: 16px;
	cursor: pointer;
	border-radius: 8px;
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;
	min-height: 160.75px;
}

.occupied-slot:hover {
	transform: translateY(-2px);
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.occupied-slot::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 100%);
	pointer-events: none;
}

.slot-content {
	position: relative;
	z-index: 1;
}

.slot-position {
	font-weight: 700;
	font-size: 1.2rem;
	text-align: center;
	margin-bottom: 8px;
	padding: 4px 8px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 4px;
}

.slot-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
	gap: 8px;
}

.slot-quantity, .slot-items {
	display: flex;
	align-items: center;
	gap: 4px;
	font-size: 0.875rem;
	background: rgba(255, 255, 255, 0.2);
	padding: 2px 8px;
	border-radius: 12px;
}

.slot-details {
	margin-bottom: 8px;
}

.slot-type, .slot-category {
	font-size: 0.875rem;
	text-align: center;
	margin-bottom: 4px;
	opacity: 0.9;
	font-weight: bold;
}

.slot-code {
	display: block;
	margin: 0 auto;
	width: fit-content;
}

/* Status Classes */
.slot-status-good {
	background: linear-gradient(135deg, #28e32e 0%, #67d16c 100%);
}

.slot-status-warning {
	background: linear-gradient(135deg, #f86b37 0%, #ffa81d 100%);
}

.slot-status-danger {
	background: linear-gradient(135deg, #b2b2b4 0%, #757577 100%);
	/* color: #1A1A1A; */
}

/* Empty Slot */
.empty-slot {
	background: linear-gradient(135deg, #e7f1ff 0%, #f5f8ff 100%);
	border: 2px dashed #4caf50;
	padding: 20px;
	cursor: pointer;
	border-radius: 8px;
	transition: all 0.3s ease;
	min-height: 120px;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 160.75px;
}

/* .empty-slot:hover {
	transform: translateY(-2px);
	box-shadow: 0 8px 25px rgba(76, 175, 80, 0.2);
	border-color: #2e7d32;
} */

.empty-content {
	text-align: center;
	color: #2e7d32;
}

.empty-position {
	font-weight: 700;
	font-size: 1.1rem;
	margin: 8px 0 4px 0;
}

.empty-text {
	font-size: 0.875rem;
	opacity: 0.8;
}

/* Responsive Design */
@media (max-width: 768px) {
	.warehouse-container {
		padding: 16px;
	}
	
	.warehouse-grid {
		gap: 16px;
	}
	
	.column-section {
		min-width: 160px;
	}
	
	.occupied-slot {
		padding: 12px;
	}
	
	.slot-position {
		font-size: 1rem;
	}
	
	.header-content {
		flex-direction: column;
		gap: 12px;
		text-align: center;
	}
	
	.warehouse-title {
		font-size: 1.25rem;
	}
}

@media (max-width: 480px) {
	.column-section {
		min-width: 140px;
	}
	
	.slot-info {
		flex-direction: column;
		gap: 4px;
	}
	
	.filter-content {
		padding: 16px;
	}
}
</style>